import { dropStatusDocumento, dropStatusGarantia } from 'utils/drops';

const getGarantiasFilterFields = (drops = {}, user, isAdmin) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'situacao',
    column: 'status',
    label: 'Situação',
    type: 'select',
    options: dropStatusGarantia,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    defaultValue: '',
    initial: true,
  },
  {
    name: 'dtemissao.i',
    column: 'documento',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtemissao.f',
    column: 'documento',
    label: 'Data de Emissão Final',
    type: 'date',
    defaultValue: null,
  },
  ...(isAdmin
    ? [
        {
          name: 'user',
          column: 'documento',
          label: 'Emitente',
          type: 'select',
          options: drops?.Users,
          multiple: true,
          defaultValue: [user?.id],
        },
      ]
    : []),
  {
    name: 'filial',
    column: 'documento',
    label: 'Filial',
    type: 'select',
    options: drops?.Filial,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'vendedor',
    column: 'documento',
    label: 'Vendedor',
    type: 'select',
    options: drops?.EntidadeTipo?.filter((f) => f?.tipo === 'VENDEDOR'),
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'cliente',
    column: 'documento',
    label: 'Cliente',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'fabricante',
    column: 'documento',
    label: 'Código do Fabricante',
    defaultValue: '',
  },
  { name: 'produto', label: 'Produto', defaultValue: '' },
  { name: 'referencia', label: 'Referência', defaultValue: '' },
  {
    name: 'quantidade',
    column: 'produto',
    label: 'Quantidade',
    type: 'currency',
    defaultValue: '',
  },
  {
    name: 'preco',
    column: 'produto',
    label: 'Preço',
    type: 'currency',
    defaultValue: '',
  },
  {
    name: 'unidade_medida',
    column: 'produto',
    label: 'Unidade de Medida',
    type: 'select',
    options: drops?.UnidadeMedida,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'marca',
    column: 'produto',
    label: 'Marca',
    type: 'select',
    options: drops?.Marca,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'serial_number',
    column: 'produto',
    label: 'Nº de Série',
    defaultValue: '',
  },
  {
    name: 'numero_nf_compra',
    column: 'produto',
    label: 'Nº da NF de Compra',
    defaultValue: '',
  },
  {
    name: 'data_nf_compra.i',
    column: 'produto',
    label: 'Data da NF de Compra Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'data_nf_compra.f',
    column: 'produto',
    label: 'Data da NF de Compra Final',
    type: 'date',
    defaultValue: null,
  },
];

export default getGarantiasFilterFields;
